// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Person20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Person20CircleFilled: FC<Person20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM9.875 11.125A2.893 2.893 0 0 0 12 12c.833 0 1.542-.292 2.125-.875A2.893 2.893 0 0 0 15 9c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 12 6c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 9 9c0 .833.292 1.542.875 2.125ZM6 16v2h12v-2c0-.32-.087-.625-.26-.917a2.009 2.009 0 0 0-.72-.708 10.223 10.223 0 0 0-2.426-1.02 9.694 9.694 0 0 0-5.188 0c-.854.235-1.663.576-2.427 1.02a2.22 2.22 0 0 0-.719.719c-.173.285-.26.587-.26.906Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Person20CircleFilled;
